import { ITEM } from '../../../../utils/ServiceUtils';
import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IGetCodebookRequest extends IBaseRequest {
    id: string;
    systemId?: string;
}

export class GetCodebookRequest extends BaseRequest implements IGetCodebookRequest {
    public id: string;
    public systemId?: string;
  constructor(server: string, session: string, id: string, systemId?: string) {
    super(server, session);
    this.id = id;
    this.systemId = systemId;
  }

  public toXml(): string {
    var parameters: string = super.toXml();
    
    parameters += this.makeNode(this.id, 'id');
    parameters += this.makeNode(this.systemId, 'systemId');

    return super.wrapperXml(ITEM.getCodebook, parameters);
  }
}
